"use client";
import Image from "next/image";
import { AnimatePresence, motion } from "framer-motion";
import { IoClose } from "react-icons/io5";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { usePath } from "../contexts/PathContext";
import { fetchBulletin } from "../lib/newApi";

export default function PopAd() {
  const { isMerchantPage } = usePath();
  const router = useRouter();

  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  // ✅ 在客戶端才檢查 localStorage
  useEffect(() => {
    const lastShow = localStorage.getItem("lastShowTime");
    const today = new Date().toDateString();
    setIsOpen(lastShow !== today);
  }, []);

  const params = isMerchantPage ? "1,3" : "1,2";
  const {
    data: adData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["popAd"],
    queryFn: async () => {
      const res = await fetchBulletin({ target: params });
      // console.log(res.data);
      return res.data;
    },
    staleTime: 1000 * 60 * 5, // 5 分鐘不 refetch
    gcTime: 1000 * 60 * 10, // 10 分鐘內保留快取
  });

  // 如果正在載入或沒有資料，不顯示彈窗
  if (isLoading || !adData) return null;

  if (isError) {
    console.error("Bulletin Api請求失敗", error);
    return null;
  }

  // 如果有選擇今日不再顯示，則不再顯示彈窗
  const handleNoShowAgain = () => {
    if (isChecked) {
      const today = new Date().toDateString();
      localStorage.setItem("lastShowTime", today);
    }
    setIsOpen(false);
  };

  const toPage = () => {
    if (isChecked) {
      const today = new Date().toDateString();
      localStorage.setItem("lastShowTime", today);
    }
    if (adData.link_type === 2) {
      router.push(`/news/newspage/?id=${adData.announcement_id}`);
    } else if (adData.link_type === 3) {
      window.open(adData.link, "_blank");
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="inset-0 fixed z-50 bg-[#00000071] flex justify-center items-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex flex-col bg-white max-w-[400px] min-w-[300px] rounded-lg relative p-5">
            <button
              type="button"
              className="absolute top-2 right-2"
              onClick={() => handleNoShowAgain()}
            >
              <IoClose size={24} />
            </button>
            <div className="grid gap-2 mt-5">
              <h3 className="font-semibold text-lg text-center">
                {adData.title}
              </h3>
              {adData.image_path && (
                <figure className="w-full h-[140px] aspect-video">
                  <Image
                    src={adData.image_path || "/example.jpg"}
                    width={300}
                    height={300}
                    className="object-contain h-full w-full"
                    quality={60}
                    alt={adData.title || "廣告圖片"}
                  />
                </figure>
              )}
              <p className="overflow-ellipsis line-clamp-4">{adData.content}</p>
            </div>
            <div className="mb-1 mt-4">
              {adData.link_type !== 1 && (
                <button
                  type="button"
                  onClick={toPage}
                  className="w-full bg-gray-400 text-white text-center block mb-2 py-1 rounded-md"
                >
                  查看更多
                </button>
              )}

              <button
                type="button"
                onClick={handleNoShowAgain}
                className={`w-full bg-primary-blue text-white text-center block py-1 rounded-md ${
                  adData.link_type === 1 && "py-2"
                } `}
              >
                我知道了
              </button>
            </div>
            <div>
              <input
                type="checkbox"
                id="no_more_show"
                name="no_more_show"
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <label htmlFor="no_more_show">今日不再顯示</label>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
